import { EMPTY_COLLECTION_MODEL } from "presentation/model/Collection/CollectionModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: CollectionProvider,
    useTracked: useCollectionTracked
} = createContainer(() => useState(EMPTY_COLLECTION_MODEL), { concurrentMode: true });
export { CollectionProvider, useCollectionTracked };

